import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledSkipToContentLink } from './SkipToContentLink.styled';

const SkipToContentLink: React.FC<{}> = () => (
  <StyledSkipToContentLink href="#main">
    <FormattedMessage id="message.skipToContent" />
  </StyledSkipToContentLink>
);

export default SkipToContentLink;
